import BaseComponent from '../abstracts/BaseComponent';

export default class BurgerComponent extends BaseComponent {
  constructor(element) {
    super(element);

    this.bindChange();
  }

  bindChange() {
    this.$on('click.cl', (e) => {
      const body = document.querySelector('body');
      body.classList.toggle('menu-in');
      if (!body.classList.contains('menu-in')) {
        this.EMIT(this.CUSTOM_MESSAGES.INPAGE_LAYER_EVENTS.close);
      }

      this.EMIT(this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.hide);
    });
  }
}
